var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", [_vm._v("Questionnaire")]),
    _vm._v(" "),
    _c("div", { staticClass: "pta-content-quest" }, [
      _c("div", { staticClass: "pta-content-left" }, [
        _vm.is_loading && !_vm.is_premium
          ? _c("h2", { staticStyle: { "margin-bottom": "20px" } }, [
              _vm._v(
                "Complete our first questionnaire and receive some free, suitable investor insights."
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("ul", [
          _c(
            "li",
            {
              class: _vm.step > 1 ? "ready" : "",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.step = 1
                },
              },
            },
            [
              _c("h3", [_vm._v("Tell us about you")]),
              _vm._v(" "),
              _c("span", { staticClass: "pta-time" }, [
                _vm._v("Takes 1 - 2 mins"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-clear" }),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: _vm.step > 2 ? "ready" : _vm.step < 2 ? "inactive" : "",
              style: _vm.questionnaire_step < 2 ? "cursor:inherit" : "",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.questionnaire_step > 1 ? (_vm.step = 2) : false
                },
              },
            },
            [
              _c("h3", [_vm._v("Tell us about your ideal investors")]),
              _vm._v(" "),
              _c("span", { staticClass: "pta-time" }, [
                _vm._v("Takes 1 - 2 mins"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-clear" }),
            ]
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              class: _vm.step > 3 ? "ready" : _vm.step < 3 ? "inactive" : "",
              style: _vm.questionnaire_step < 3 ? "cursor:inherit" : "",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.questionnaire_step > 2 ? (_vm.step = 3) : false
                },
              },
            },
            [
              _c("h3", [_vm._v("Tell us about your offering")]),
              _vm._v(" "),
              _c("span", { staticClass: "pta-time" }, [
                _vm._v("Takes 1 - 2 mins"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pta-clear" }),
            ]
          ),
          _vm._v(" "),
          _vm.is_premium
            ? _c(
                "li",
                {
                  class:
                    _vm.step > 4 ? "ready" : _vm.step < 4 ? "inactive" : "",
                  style: _vm.questionnaire_step < 4 ? "cursor:inherit" : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.questionnaire_step > 3 ? (_vm.step = 4) : false
                    },
                  },
                },
                [
                  _c("h3", [_vm._v("Tell us about your track record")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pta-time" }, [
                    _vm._v("Takes 5 - 20 mins"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pta-clear" }),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.is_premium
            ? _c(
                "li",
                {
                  class:
                    _vm.step > 5 ? "ready" : _vm.step < 5 ? "inactive" : "",
                  style: _vm.questionnaire_step < 4 ? "cursor:inherit" : "",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.questionnaire_step > 3 ? (_vm.step = 5) : false
                    },
                  },
                },
                [
                  _c("h3", [_vm._v("Tell us about your fund admin")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "pta-time" }, [
                    _vm._v("Takes 5 - 20 mins"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "pta-clear" }),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "pta-content-right",
          style: _vm.is_loading && !_vm.is_premium ? "" : "padding-top:0;",
        },
        [
          _c("div", {
            staticClass: "pta-status",
            class: "pta-status-" + _vm.step,
          }),
          _vm._v(" "),
          _vm.is_loading
            ? _c("div", { staticClass: "pta-loading" }, [
                _vm._v("Data is loading ..."),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step == 1 && !_vm.is_loading
            ? _c(
                "div",
                { staticClass: "pta-steps" },
                [
                  _c("h3", [_vm._v("PERSONAL DETAILS:")]),
                  _vm._v(" "),
                  _c("label", [_vm._v("Your Company’s Name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.company,
                        expression: "questionaireForm.company",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.company },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "company",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "company",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "20px" } }, [
                    _vm._v("Your Work Phone Number"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.phone,
                        expression: "questionaireForm.phone",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "0" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.phone },
                    on: {
                      keydown: _vm.filterInputPhone,
                      paste: _vm.filterInputPaste,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "phone",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "block",
                        "padding-top": "5px",
                        "font-size": "14px",
                        color: "#999",
                      },
                    },
                    [_vm._v("Please also add your country code.")]
                  ),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "phone",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "20px" } }, [
                    _vm._v("Where are your company's headquarters?"),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "name",
                      "track-by": "id",
                      name: "hq_country_id",
                      id: "hq_country_id",
                      options: _vm.countries,
                      placeholder: "Please choose",
                      multiple: true,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                      selected: _vm.selected_hq_countries,
                    },
                    on: {
                      select: _vm.onHQCountrySelect,
                      remove: _vm.onHQCountryRemove,
                    },
                    model: {
                      value: _vm.selected_hq_countries,
                      callback: function ($$v) {
                        _vm.selected_hq_countries = $$v
                      },
                      expression: "selected_hq_countries",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        display: "block",
                        "padding-top": "5px",
                        "font-size": "14px",
                        color: "#999",
                      },
                    },
                    [
                      _vm._v(
                        'Start typing your country name in the box and press "choose" to select.'
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "hq_country_id",
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("autosize-textarea", {
                    attrs: {
                      placeholder: "",
                      rows: "2",
                      name: "company_description",
                    },
                    model: {
                      value: _vm.questionaireForm.company_description,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.questionaireForm,
                          "company_description",
                          $$v
                        )
                      },
                      expression: "questionaireForm.company_description",
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "company_description",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("h3", { staticStyle: { "padding-top": "50px" } }, [
                        _vm._v("TEAM MEMBERS:"),
                      ]),
                      _vm._v(" "),
                      _c("label", [
                        _vm._v(
                          "Please insert the name of the first team member"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.team_member_1_name,
                            expression: "questionaireForm.team_member_1_name",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.team_member_1_name,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "team_member_1_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v(
                          "Please insert the job title of the first team member"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.team_member_1_jobtitle,
                            expression:
                              "questionaireForm.team_member_1_jobtitle",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.team_member_1_jobtitle,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "team_member_1_jobtitle",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "team_member_1_jobtitle",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticStyle: {
                            "padding-top": "10px",
                            "padding-right": "110px",
                          },
                        },
                        [
                          _vm._v(
                            "Can you describe this person’s main responsibilities?\n              "
                          ),
                          !_vm.questionaireForm
                            .team_member_1_responsibilities_ai &&
                          !_vm.is_ai_values
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value:
                                        "Please complete the questionnaire before you can use the AI Generator.",
                                      expression:
                                        "'Please complete the questionnaire before you can use the AI Generator.'",
                                    },
                                  ],
                                  staticClass: "pta-ai-link",
                                  staticStyle: {
                                    float: "right",
                                    opacity: "0.6",
                                  },
                                },
                                [_vm._v("Generator")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.questionaireForm
                            .team_member_1_responsibilities_ai &&
                          _vm.is_ai_values_1
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value:
                                        "Here you can create the description of the member via our AI Generator.",
                                      expression:
                                        "'Here you can create the description of the member via our AI Generator.'",
                                    },
                                  ],
                                  staticClass: "pta-ai-link",
                                  staticStyle: { float: "right" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.loadAI(1)
                                    },
                                  },
                                },
                                [_vm._v("Generator")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.questionaireForm.team_member_1_responsibilities_ai
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value:
                                        "Here you can load the AI generated description of the member.",
                                      expression:
                                        "'Here you can load the AI generated description of the member.'",
                                    },
                                  ],
                                  staticClass: "pta-ai-link",
                                  staticStyle: { float: "right" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.questionaireForm.team_member_1_responsibilities =
                                        _vm.questionaireForm.team_member_1_responsibilities_ai
                                    },
                                  },
                                },
                                [_vm._v("Description")]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "pta-form-text-ai",
                          staticStyle: { position: "relative" },
                        },
                        [
                          _c("autosize-textarea", {
                            attrs: {
                              placeholder: "",
                              rows: "2",
                              name: "team_member_1_responsibilities",
                            },
                            model: {
                              value:
                                _vm.questionaireForm
                                  .team_member_1_responsibilities,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.questionaireForm,
                                  "team_member_1_responsibilities",
                                  $$v
                                )
                              },
                              expression:
                                "questionaireForm.team_member_1_responsibilities",
                            },
                          }),
                          _vm._v(" "),
                          _vm.is_team_member_1_responsibilities_loading
                            ? _c("span", [_vm._v("Loading ...")])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "team_member_1_responsibilities",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "30px" } }, [
                        _vm._v(
                          "Please insert the name of the second team member"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.team_member_2_name,
                            expression: "questionaireForm.team_member_2_name",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.team_member_2_name,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "team_member_2_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "team_member_2_name",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v(
                          "Please insert the job title of the second team member"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.team_member_2_jobtitle,
                            expression:
                              "questionaireForm.team_member_2_jobtitle",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.team_member_2_jobtitle,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "team_member_2_jobtitle",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "team_member_2_jobtitle",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticStyle: {
                            "padding-top": "10px",
                            "padding-right": "110px",
                          },
                        },
                        [
                          _vm._v(
                            "Can you describe this person’s main responsibilities?\n              "
                          ),
                          !_vm.questionaireForm
                            .team_member_2_responsibilities_ai &&
                          !_vm.is_ai_values
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value:
                                        "Please complete the questionnaire before you can use the AI Generator.",
                                      expression:
                                        "'Please complete the questionnaire before you can use the AI Generator.'",
                                    },
                                  ],
                                  staticClass: "pta-ai-link",
                                  staticStyle: {
                                    float: "right",
                                    opacity: "0.6",
                                  },
                                },
                                [_vm._v("Generator")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.questionaireForm
                            .team_member_2_responsibilities_ai &&
                          _vm.is_ai_values_2
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value:
                                        "Here you can create the description of the member via our AI Generator.",
                                      expression:
                                        "'Here you can create the description of the member via our AI Generator.'",
                                    },
                                  ],
                                  staticClass: "pta-ai-link",
                                  staticStyle: { float: "right" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.loadAI(2)
                                    },
                                  },
                                },
                                [_vm._v("Generator")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.questionaireForm.team_member_2_responsibilities_ai
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value:
                                        "Here you can load the AI generated description of the member.",
                                      expression:
                                        "'Here you can load the AI generated description of the member.'",
                                    },
                                  ],
                                  staticClass: "pta-ai-link",
                                  staticStyle: { float: "right" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.questionaireForm.team_member_2_responsibilities =
                                        _vm.questionaireForm.team_member_2_responsibilities_ai
                                    },
                                  },
                                },
                                [_vm._v("Description")]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "pta-form-text-ai",
                          staticStyle: { position: "relative" },
                        },
                        [
                          _c("autosize-textarea", {
                            attrs: {
                              placeholder: "",
                              rows: "2",
                              name: "team_member_2_responsibilities",
                            },
                            model: {
                              value:
                                _vm.questionaireForm
                                  .team_member_2_responsibilities,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.questionaireForm,
                                  "team_member_2_responsibilities",
                                  $$v
                                )
                              },
                              expression:
                                "questionaireForm.team_member_2_responsibilities",
                            },
                          }),
                          _vm._v(" "),
                          _vm.is_team_member_2_responsibilities_loading
                            ? _c("span", [_vm._v("Loading ...")])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "team_member_2_responsibilities",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "30px" } }, [
                        _vm._v(
                          "Please insert the name of the third team member"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.team_member_3_name,
                            expression: "questionaireForm.team_member_3_name",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.team_member_3_name,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "team_member_3_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "team_member_3_name",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v(
                          "Please insert the job title of the third team member"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.team_member_3_jobtitle,
                            expression:
                              "questionaireForm.team_member_3_jobtitle",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.team_member_3_jobtitle,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "team_member_3_jobtitle",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "team_member_3_jobtitle",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticStyle: {
                            "padding-top": "10px",
                            "padding-right": "110px",
                          },
                        },
                        [
                          _vm._v(
                            "Can you describe this person’s main responsibilities?\n              "
                          ),
                          !_vm.questionaireForm
                            .team_member_3_responsibilities_ai &&
                          !_vm.is_ai_values
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value:
                                        "Please complete the questionnaire before you can use the AI Generator.",
                                      expression:
                                        "'Please complete the questionnaire before you can use the AI Generator.'",
                                    },
                                  ],
                                  staticClass: "pta-ai-link",
                                  staticStyle: {
                                    float: "right",
                                    opacity: "0.6",
                                  },
                                },
                                [_vm._v("Generator")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.questionaireForm
                            .team_member_3_responsibilities_ai &&
                          _vm.is_ai_values_3
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value:
                                        "Here you can create the description of the member via our AI Generator.",
                                      expression:
                                        "'Here you can create the description of the member via our AI Generator.'",
                                    },
                                  ],
                                  staticClass: "pta-ai-link",
                                  staticStyle: { float: "right" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.loadAI(3)
                                    },
                                  },
                                },
                                [_vm._v("Generator")]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.questionaireForm.team_member_3_responsibilities_ai
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value:
                                        "Here you can load the AI generated description of the member.",
                                      expression:
                                        "'Here you can load the AI generated description of the member.'",
                                    },
                                  ],
                                  staticClass: "pta-ai-link",
                                  staticStyle: { float: "right" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.questionaireForm.team_member_3_responsibilities =
                                        _vm.questionaireForm.team_member_3_responsibilities_ai
                                    },
                                  },
                                },
                                [_vm._v("Description")]
                              )
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "pta-form-text-ai",
                          staticStyle: { position: "relative" },
                        },
                        [
                          _c("autosize-textarea", {
                            attrs: {
                              placeholder: "",
                              rows: "2",
                              name: "team_member_3_responsibilities",
                            },
                            model: {
                              value:
                                _vm.questionaireForm
                                  .team_member_3_responsibilities,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.questionaireForm,
                                  "team_member_3_responsibilities",
                                  $$v
                                )
                              },
                              expression:
                                "questionaireForm.team_member_3_responsibilities",
                            },
                          }),
                          _vm._v(" "),
                          _vm.is_team_member_3_responsibilities_loading
                            ? _c("span", [_vm._v("Loading ...")])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "team_member_3_responsibilities",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.step == 2 && !_vm.is_loading
            ? _c(
                "div",
                { staticClass: "pta-steps" },
                [
                  _c("h3", [_vm._v("INVESTOR-RELATED QUESTIONS:")]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "From which investor do you want to raise capital from in the future (high level)?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticStyle: { "margin-bottom": "0" } }, [
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.investor_types,
                            expression: "questionaireForm.investor_types",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "c1",
                          name: "c1",
                          value: "1",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.investor_types
                          )
                            ? _vm._i(_vm.questionaireForm.investor_types, "1") >
                              -1
                            : _vm._q(_vm.questionaireForm.investor_types, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.investor_types,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "1",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "investor_types",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "investor_types",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "investor_types",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "c1" } }, [
                        _vm._v("High-net-worth Investor"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.investor_types,
                            expression: "questionaireForm.investor_types",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "c2",
                          name: "c2",
                          value: "2",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.investor_types
                          )
                            ? _vm._i(_vm.questionaireForm.investor_types, "2") >
                              -1
                            : _vm._q(_vm.questionaireForm.investor_types, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.investor_types,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "2",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "investor_types",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "investor_types",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "investor_types",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "c2" } }, [
                        _vm._v("Family Offices"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.investor_types,
                            expression: "questionaireForm.investor_types",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "c3",
                          name: "c3",
                          value: "3",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.investor_types
                          )
                            ? _vm._i(_vm.questionaireForm.investor_types, "3") >
                              -1
                            : _vm._q(_vm.questionaireForm.investor_types, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.investor_types,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "3",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "investor_types",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "investor_types",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "investor_types",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "c3" } }, [
                        _vm._v("Institutional Investor"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "investor_types",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "20px" } }, [
                    _vm._v(
                      "From which main country should your ideal investor come from?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "name",
                      "track-by": "id",
                      name: "main_country_id",
                      id: "main_country_id",
                      options: _vm.countries,
                      placeholder: "Please choose",
                      multiple: true,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                      selected: _vm.selected_main_countries,
                    },
                    on: {
                      select: _vm.onMainCountrySelect,
                      remove: _vm.onMainCountryRemove,
                    },
                    model: {
                      value: _vm.selected_main_countries,
                      callback: function ($$v) {
                        _vm.selected_main_countries = $$v
                      },
                      expression: "selected_main_countries",
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "main_country_id",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.step == 3 && !_vm.is_loading
            ? _c(
                "div",
                { staticClass: "pta-steps" },
                [
                  _c("h3", [_vm._v("ABOUT YOUR FUND / DEAL:")]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("In which Asset Class are you investing?"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.questionaireForm.fund_category_id,
                          expression: "questionaireForm.fund_category_id",
                        },
                      ],
                      staticClass: "custom-select",
                      attrs: { id: "continent_2_id" },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.questionaireForm,
                              "fund_category_id",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.getFundTypes,
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v("Please choose the fund category"),
                      ]),
                      _vm._v(" "),
                      _vm._l(_vm.fund_categories, function (fund_category) {
                        return _c(
                          "option",
                          { domProps: { value: fund_category.id } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(fund_category.name) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "fund_category_id",
                    },
                  }),
                  _vm._v(" "),
                  _vm.fund_types_cur && _vm.questionaireForm.fund_category_id
                    ? _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.questionaireForm.fund_type_id,
                              expression: "questionaireForm.fund_type_id",
                            },
                          ],
                          staticClass: "custom-select",
                          staticStyle: { "margin-top": "10px" },
                          attrs: { id: "fund_type_id" },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.questionaireForm,
                                "fund_type_id",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                          },
                        },
                        [
                          _c("option", { attrs: { value: "" } }, [
                            _vm._v("Please choose the fund type"),
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.fund_types_cur, function (fund_type) {
                            return _c(
                              "option",
                              { domProps: { value: fund_type.id } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(fund_type.name) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.questionaireForm.fund_category_id
                    ? _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "fund_type_id",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "30px" } }, [
                    _vm._v("Where are you investing primarily?"),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "name",
                      "track-by": "id",
                      name: "asset_country_id",
                      id: "asset_country_id",
                      options: _vm.countries,
                      placeholder: "Please choose",
                      multiple: true,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                      selected: _vm.selected_asset_countries,
                    },
                    on: {
                      select: _vm.onAssetCountrySelect,
                      remove: _vm.onAssetCountryRemove,
                    },
                    model: {
                      value: _vm.selected_asset_countries,
                      callback: function ($$v) {
                        _vm.selected_asset_countries = $$v
                      },
                      expression: "selected_asset_countries",
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "asset_country_id",
                    },
                  }),
                  _vm._v(" "),
                  _vm.is_premium
                    ? _c(
                        "div",
                        [
                          _c(
                            "label",
                            { staticStyle: { "padding-top": "30px" } },
                            [
                              _vm._v(
                                "In what Country is your investment vehicle domiciled?"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              label: "name",
                              "track-by": "id",
                              name: "iv_country_id",
                              id: "iv_country_id",
                              options: _vm.countries,
                              placeholder: "Please choose",
                              multiple: false,
                              "close-on-select": true,
                              "clear-on-select": false,
                              "hide-selected": true,
                              placeholder: "Please choose",
                              selectLabel: "choose",
                            },
                            model: {
                              value: _vm.iv_country_id,
                              callback: function ($$v) {
                                _vm.iv_country_id = $$v
                              },
                              expression: "iv_country_id",
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.questionaireForm,
                              "prop-name": "iv_country_id",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticStyle: { "padding-top": "30px" } },
                            [
                              _vm._v(
                                "What is the investment vehicle's currency?"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              label: "name",
                              "track-by": "id",
                              name: "currency_id",
                              id: "currency_id",
                              options: _vm.currencies,
                              placeholder: "Please choose",
                              multiple: false,
                              "close-on-select": true,
                              "clear-on-select": false,
                              "hide-selected": true,
                              placeholder: "Please choose",
                              selectLabel: "choose",
                            },
                            model: {
                              value: _vm.currency_id,
                              callback: function ($$v) {
                                _vm.currency_id = $$v
                              },
                              expression: "currency_id",
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.questionaireForm,
                              "prop-name": "currency_id",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticStyle: { "padding-top": "30px" } },
                            [
                              _vm._v(
                                "What is the expected holding period (in years)?"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.questionaireForm.holding_period,
                                  expression: "questionaireForm.holding_period",
                                },
                              ],
                              staticClass: "custom-select",
                              attrs: { id: "holding_period" },
                              on: {
                                change: function ($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "holding_period",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                },
                              },
                            },
                            [
                              _c("option", { attrs: { value: "0" } }, [
                                _vm._v("Please choose"),
                              ]),
                              _vm._v(" "),
                              _vm._l(30, function (index) {
                                return _c(
                                  "option",
                                  { domProps: { value: index } },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(index) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.questionaireForm,
                              "prop-name": "holding_period",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticStyle: { "padding-top": "30px" } },
                            [
                              _vm._v(
                                "Are you a member of any ESG associations?"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("ul", { staticStyle: { "margin-bottom": "0" } }, [
                            _c("li", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.questionaireForm.esg,
                                    expression: "questionaireForm.esg",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "esg_yes",
                                  name: "esg",
                                  value: "Yes",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.questionaireForm.esg,
                                    "Yes"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.questionaireForm,
                                      "esg",
                                      "Yes"
                                    )
                                  },
                                },
                              }),
                              _c("label", { attrs: { for: "esg_yes" } }, [
                                _vm._v("Yes"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.questionaireForm.esg,
                                    expression: "questionaireForm.esg",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "esg_no",
                                  name: "esg",
                                  value: "No",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.questionaireForm.esg,
                                    "No"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.questionaireForm,
                                      "esg",
                                      "No"
                                    )
                                  },
                                },
                              }),
                              _c("label", { attrs: { for: "esg_no" } }, [
                                _vm._v("No"),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.questionaireForm,
                              "prop-name": "esg",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticStyle: { "padding-top": "30px" } },
                            [_vm._v("What is your Investment Structure?")]
                          ),
                          _vm._v(" "),
                          _c("ul", { staticStyle: { "margin-bottom": "0" } }, [
                            _c("li", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.questionaireForm.inv_struct,
                                    expression: "questionaireForm.inv_struct",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "inv_struct_direct_deal",
                                  name: "inv_struct",
                                  value: "Direct Deal Investment",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.questionaireForm.inv_struct,
                                    "Direct Deal Investment"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.questionaireForm,
                                      "inv_struct",
                                      "Direct Deal Investment"
                                    )
                                  },
                                },
                              }),
                              _c(
                                "label",
                                { attrs: { for: "inv_struct_direct_deal" } },
                                [_vm._v("Direct Deal Investment")]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.questionaireForm.inv_struct,
                                    expression: "questionaireForm.inv_struct",
                                  },
                                ],
                                attrs: {
                                  type: "radio",
                                  id: "inv_struct_fund",
                                  name: "inv_struct",
                                  value: "Fund Investment",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.questionaireForm.inv_struct,
                                    "Fund Investment"
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.questionaireForm,
                                      "inv_struct",
                                      "Fund Investment"
                                    )
                                  },
                                },
                              }),
                              _c(
                                "label",
                                { attrs: { for: "inv_struct_fund" } },
                                [_vm._v("Fund Investment")]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.questionaireForm,
                              "prop-name": "inv_struct",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticStyle: { "padding-top": "30px" } },
                            [
                              _vm._v(
                                "What is the total capital raising target for your offering (In USD Millions)?"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.questionaireForm.total_capital,
                                expression: "questionaireForm.total_capital",
                              },
                            ],
                            staticClass: "pta-form-text",
                            staticStyle: { "margin-bottom": "0" },
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.questionaireForm.total_capital,
                            },
                            on: {
                              keypress: _vm.onlyAmount,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.questionaireForm,
                                  "total_capital",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.questionaireForm,
                              "prop-name": "total_capital",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticStyle: { "padding-top": "30px" } },
                            [
                              _vm._v(
                                "What is your target gross return (IRR %)?"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.questionaireForm.irr,
                                expression: "questionaireForm.irr",
                              },
                            ],
                            staticClass: "pta-form-text",
                            staticStyle: { "margin-bottom": "0" },
                            attrs: { type: "text" },
                            domProps: { value: _vm.questionaireForm.irr },
                            on: {
                              keypress: _vm.onlyAmount,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.questionaireForm,
                                  "irr",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.questionaireForm,
                              "prop-name": "irr",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticStyle: { "padding-top": "30px" } },
                            [
                              _vm._v(
                                "What is your target gross Equity Multiple / MOIC (x)?"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.questionaireForm.moic,
                                expression: "questionaireForm.moic",
                              },
                            ],
                            staticClass: "pta-form-text",
                            staticStyle: { "margin-bottom": "0" },
                            attrs: { type: "text" },
                            domProps: { value: _vm.questionaireForm.moic },
                            on: {
                              keypress: _vm.onlyAmount,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.questionaireForm,
                                  "moic",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.questionaireForm,
                              "prop-name": "moic",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticStyle: { "padding-top": "30px" } },
                            [
                              _vm._v(
                                "What is the minimum investment ticket size acceptable (In USD Millions)?"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.questionaireForm.ticket_size,
                                expression: "questionaireForm.ticket_size",
                              },
                            ],
                            staticClass: "pta-form-text",
                            staticStyle: { "margin-bottom": "0" },
                            attrs: { type: "text" },
                            domProps: {
                              value: _vm.questionaireForm.ticket_size,
                            },
                            on: {
                              keypress: _vm.onlyAmount,
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.questionaireForm,
                                  "ticket_size",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.questionaireForm,
                              "prop-name": "ticket_size",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            { staticStyle: { "padding-top": "30px" } },
                            [_vm._v("Describe your investment strategy")]
                          ),
                          _vm._v(" "),
                          _c("autosize-textarea", {
                            attrs: {
                              placeholder:
                                "Example: Providing bridge and mezzanine loans for middle-market companies across the UK.",
                              rows: "2",
                              name: "strategy",
                            },
                            model: {
                              value: _vm.questionaireForm.strategy,
                              callback: function ($$v) {
                                _vm.$set(_vm.questionaireForm, "strategy", $$v)
                              },
                              expression: "questionaireForm.strategy",
                            },
                          }),
                          _vm._v(" "),
                          _c("show-error", {
                            attrs: {
                              "form-name": _vm.questionaireForm,
                              "prop-name": "strategy",
                            },
                          }),
                          _vm._v(" "),
                          _vm.questionaireForm.inv_struct == "Fund Investment"
                            ? _c(
                                "div",
                                [
                                  _c(
                                    "label",
                                    { staticStyle: { "padding-top": "30px" } },
                                    [_vm._v("What is your fund status?")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticStyle: { "margin-bottom": "0" } },
                                    [
                                      _c("li", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.questionaireForm
                                                  .fund_status,
                                              expression:
                                                "questionaireForm.fund_status",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            id: "fund_status_yes",
                                            name: "fund_status",
                                            value: "Closed Ended",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.questionaireForm.fund_status,
                                              "Closed Ended"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.questionaireForm,
                                                "fund_status",
                                                "Closed Ended"
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "label",
                                          { attrs: { for: "fund_status_yes" } },
                                          [_vm._v("Closed Ended")]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.questionaireForm
                                                  .fund_status,
                                              expression:
                                                "questionaireForm.fund_status",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            id: "fund_status_no",
                                            name: "fund_status",
                                            value: "Open Ended",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.questionaireForm.fund_status,
                                              "Open Ended"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.questionaireForm,
                                                "fund_status",
                                                "Open Ended"
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "label",
                                          { attrs: { for: "fund_status_no" } },
                                          [_vm._v("Open Ended")]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("show-error", {
                                    attrs: {
                                      "form-name": _vm.questionaireForm,
                                      "prop-name": "fund_status",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticStyle: { "padding-top": "30px" } },
                                    [_vm._v("Is this a first time fund?")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticStyle: { "margin-bottom": "0" } },
                                    [
                                      _c("li", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.questionaireForm
                                                  .fund_first_time,
                                              expression:
                                                "questionaireForm.fund_first_time",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            id: "fund_first_time_yes",
                                            name: "fund_first_time",
                                            value: "Yes",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.questionaireForm
                                                .fund_first_time,
                                              "Yes"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.questionaireForm,
                                                "fund_first_time",
                                                "Yes"
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "fund_first_time_yes",
                                            },
                                          },
                                          [_vm._v("Yes")]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.questionaireForm
                                                  .fund_first_time,
                                              expression:
                                                "questionaireForm.fund_first_time",
                                            },
                                          ],
                                          attrs: {
                                            type: "radio",
                                            id: "fund_first_time_no",
                                            name: "fund_first_time",
                                            value: "No",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.questionaireForm
                                                .fund_first_time,
                                              "No"
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.questionaireForm,
                                                "fund_first_time",
                                                "No"
                                              )
                                            },
                                          },
                                        }),
                                        _c(
                                          "label",
                                          {
                                            attrs: {
                                              for: "fund_first_time_no",
                                            },
                                          },
                                          [_vm._v("No")]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("show-error", {
                                    attrs: {
                                      "form-name": _vm.questionaireForm,
                                      "prop-name": "fund_first_time",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticStyle: { "padding-top": "30px" } },
                                    [_vm._v("Expected Timing of First Close")]
                                  ),
                                  _vm._v(" "),
                                  _c("VueCtkDateTimePicker", {
                                    attrs: {
                                      format: "YYYY-MM-DD",
                                      "no-label": true,
                                      "no-header": false,
                                      formatted: "DD.MM.YYYY",
                                      color: "#20365F",
                                      "only-date": true,
                                      label: "none",
                                      "button-now-translation": "today",
                                    },
                                    model: {
                                      value:
                                        _vm.questionaireForm.fund_first_close,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.questionaireForm,
                                          "fund_first_close",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "questionaireForm.fund_first_close",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("show-error", {
                                    attrs: {
                                      "form-name": _vm.questionaireForm,
                                      "prop-name": "fund_first_close",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticStyle: { "padding-top": "30px" } },
                                    [_vm._v("Expected Timing of Final Close")]
                                  ),
                                  _vm._v(" "),
                                  _c("VueCtkDateTimePicker", {
                                    attrs: {
                                      disabled: _vm.questionaireForm
                                        .fund_first_close
                                        ? false
                                        : true,
                                      minDate:
                                        _vm.questionaireForm.fund_first_close,
                                      format: "YYYY-MM-DD",
                                      "no-label": true,
                                      "no-header": false,
                                      formatted: "DD.MM.YYYY",
                                      color: "#20365F",
                                      "only-date": true,
                                      label: "none",
                                      "button-now-translation": "today",
                                    },
                                    model: {
                                      value:
                                        _vm.questionaireForm.fund_final_close,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.questionaireForm,
                                          "fund_final_close",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "questionaireForm.fund_final_close",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("show-error", {
                                    attrs: {
                                      "form-name": _vm.questionaireForm,
                                      "prop-name": "fund_final_close",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    { staticStyle: { "padding-top": "30px" } },
                                    [
                                      _vm._v(
                                        "Could you please provide us with the specific name of the product, or financial vehicle for which you are currently raising capital for? For instance, ‘Alpha Partners Fund III’?"
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.questionaireForm.product_name,
                                        expression:
                                          "questionaireForm.product_name",
                                      },
                                    ],
                                    staticClass: "pta-form-text",
                                    staticStyle: { "margin-bottom": "0" },
                                    attrs: { type: "text" },
                                    domProps: {
                                      value: _vm.questionaireForm.product_name,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.questionaireForm,
                                          "product_name",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("show-error", {
                                    attrs: {
                                      "form-name": _vm.questionaireForm,
                                      "prop-name": "product_name",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _c(
                                "h3",
                                { staticStyle: { "padding-top": "50px" } },
                                [_vm._v("INVESTMENTS:")]
                              ),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(
                                  "Describe your investment thesis and rationale."
                                ),
                              ]),
                              _vm._v(" "),
                              _c("autosize-textarea", {
                                attrs: {
                                  placeholder: "",
                                  rows: "2",
                                  name: "investment_thesis",
                                },
                                model: {
                                  value: _vm.questionaireForm.investment_thesis,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.questionaireForm,
                                      "investment_thesis",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "questionaireForm.investment_thesis",
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.questionaireForm,
                                  "prop-name": "investment_thesis",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { staticStyle: { "padding-top": "30px" } },
                                [
                                  _vm._v(
                                    "In which sub-sectors are you investing in (for instance, for private equity this could be TMT or ClimateTech. For real estate strategies, this could be multi-family homes)?"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("autosize-textarea", {
                                attrs: {
                                  placeholder: "",
                                  rows: "2",
                                  name: "investment_focus_subsectors",
                                },
                                model: {
                                  value:
                                    _vm.questionaireForm
                                      .investment_focus_subsectors,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.questionaireForm,
                                      "investment_focus_subsectors",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "questionaireForm.investment_focus_subsectors",
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.questionaireForm,
                                  "prop-name": "investment_focus_subsectors",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { staticStyle: { "padding-top": "30px" } },
                                [
                                  _vm._v(
                                    "Describe your investment criteria and selection process."
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("autosize-textarea", {
                                attrs: {
                                  placeholder: "",
                                  rows: "2",
                                  name: "investment_criteria",
                                },
                                model: {
                                  value:
                                    _vm.questionaireForm.investment_criteria,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.questionaireForm,
                                      "investment_criteria",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "questionaireForm.investment_criteria",
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.questionaireForm,
                                  "prop-name": "investment_criteria",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "h3",
                                { staticStyle: { "padding-top": "50px" } },
                                [_vm._v("TERMS:")]
                              ),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(
                                  "Can you describe the proceeds distribution policy?"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("autosize-textarea", {
                                attrs: {
                                  placeholder: "",
                                  rows: "2",
                                  name: "terms_policies",
                                },
                                model: {
                                  value: _vm.questionaireForm.terms_policies,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.questionaireForm,
                                      "terms_policies",
                                      $$v
                                    )
                                  },
                                  expression: "questionaireForm.terms_policies",
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.questionaireForm,
                                  "prop-name": "terms_policies",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { staticStyle: { "padding-top": "30px" } },
                                [
                                  _vm._v(
                                    "Describe the lock-up periods applicable (if any)."
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("autosize-textarea", {
                                attrs: {
                                  placeholder: "",
                                  rows: "2",
                                  name: "terms_lockup_period",
                                },
                                model: {
                                  value:
                                    _vm.questionaireForm.terms_lockup_period,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.questionaireForm,
                                      "terms_lockup_period",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "questionaireForm.terms_lockup_period",
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.questionaireForm,
                                  "prop-name": "terms_lockup_period",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { staticStyle: { "padding-top": "30px" } },
                                [
                                  _vm._v(
                                    "How much is the management fee charged (%)?"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.questionaireForm.terms_management_fee,
                                    expression:
                                      "questionaireForm.terms_management_fee",
                                  },
                                ],
                                staticClass: "pta-form-text",
                                staticStyle: { "margin-bottom": "0" },
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.questionaireForm.terms_management_fee,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.questionaireForm,
                                      "terms_management_fee",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.questionaireForm,
                                  "prop-name": "terms_management_fee",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { staticStyle: { "padding-top": "30px" } },
                                [
                                  _vm._v(
                                    "How much is the amount of carried interest charged (%)?"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.questionaireForm
                                        .terms_performance_fee,
                                    expression:
                                      "questionaireForm.terms_performance_fee",
                                  },
                                ],
                                staticClass: "pta-form-text",
                                staticStyle: { "margin-bottom": "0" },
                                attrs: { type: "text" },
                                domProps: {
                                  value:
                                    _vm.questionaireForm.terms_performance_fee,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.questionaireForm,
                                      "terms_performance_fee",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.questionaireForm,
                                  "prop-name": "terms_performance_fee",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                { staticStyle: { "padding-top": "30px" } },
                                [
                                  _vm._v(
                                    "Describe subscription and redemption terms."
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("autosize-textarea", {
                                attrs: {
                                  placeholder: "",
                                  rows: "2",
                                  name: "terms_subscription",
                                },
                                model: {
                                  value:
                                    _vm.questionaireForm.terms_subscription,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.questionaireForm,
                                      "terms_subscription",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "questionaireForm.terms_subscription",
                                },
                              }),
                              _vm._v(" "),
                              _c("show-error", {
                                attrs: {
                                  "form-name": _vm.questionaireForm,
                                  "prop-name": "terms_subscription",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.step == 4 && !_vm.is_loading && _vm.is_premium
            ? _c(
                "div",
                { staticClass: "pta-steps" },
                [
                  _c("h3", [_vm._v("ABOUT YOUR TRACK RECORD:")]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "Could you briefly outline four of your key track record highlights?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("autosize-textarea", {
                    style: "margin-bottom:10px;",
                    attrs: {
                      rows: "2",
                      name: "track_record_1",
                      placeholder:
                        "Example: Any key differentiators of your offering relative to managers in your industry.",
                    },
                    model: {
                      value: _vm.questionaireForm.track_record_1,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "track_record_1", $$v)
                      },
                      expression: "questionaireForm.track_record_1",
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    style: "margin-top:-10px;margin-bottom:10px;",
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "track_record_1",
                    },
                  }),
                  _vm._v(" "),
                  _c("autosize-textarea", {
                    style: "margin-bottom:10px;",
                    attrs: {
                      rows: "2",
                      name: "track_record_2",
                      placeholder:
                        "Example: IRR delivered in previous funds/deals.",
                    },
                    model: {
                      value: _vm.questionaireForm.track_record_2,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "track_record_2", $$v)
                      },
                      expression: "questionaireForm.track_record_2",
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    style: "margin-top:-10px;margin-bottom:10px;",
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "track_record_2",
                    },
                  }),
                  _vm._v(" "),
                  _c("autosize-textarea", {
                    style: "margin-bottom:10px;",
                    attrs: {
                      rows: "2",
                      name: "track_record_3",
                      placeholder:
                        "Example: Your team's experience in the industry.",
                    },
                    model: {
                      value: _vm.questionaireForm.track_record_3,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "track_record_3", $$v)
                      },
                      expression: "questionaireForm.track_record_3",
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    style: "margin-top:-10px;margin-bottom:10px;",
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "track_record_3",
                    },
                  }),
                  _vm._v(" "),
                  _c("autosize-textarea", {
                    style: "margin-bottom:10px;",
                    attrs: {
                      rows: "2",
                      name: "track_record_4",
                      placeholder:
                        "Example: Total amount of capital that you've raised so far.",
                    },
                    model: {
                      value: _vm.questionaireForm.track_record_4,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "track_record_4", $$v)
                      },
                      expression: "questionaireForm.track_record_4",
                    },
                  }),
                  _vm._v(" "),
                  _c("show-error", {
                    style: "margin-top:-10px;margin-bottom:10px;",
                    attrs: {
                      "form-name": _vm.questionaireForm,
                      "prop-name": "track_record_4",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("h3", { staticStyle: { "padding-top": "50px" } }, [
                        _vm._v("CASE STUDIES:"),
                      ]),
                      _vm._v(" "),
                      _c("label", [
                        _vm._v(
                          "Please insert project name of sample investment 1."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.questionaireForm.case_study_1_project_name,
                            expression:
                              "questionaireForm.case_study_1_project_name",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.case_study_1_project_name,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_1_project_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_1_project_name",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v("How much was invested?"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.questionaireForm.case_study_1_amount_invested,
                            expression:
                              "questionaireForm.case_study_1_amount_invested",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value:
                            _vm.questionaireForm.case_study_1_amount_invested,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_1_amount_invested",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_1_amount_invested",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v("What gross return did you achieve (IRR %)?"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.case_study_1_irr,
                            expression: "questionaireForm.case_study_1_irr",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.case_study_1_irr,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_1_irr",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_1_irr",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v(
                          "What gross return did you achieve (Equity Multiple / MOIC (x))?"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.case_study_1_moic,
                            expression: "questionaireForm.case_study_1_moic",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.case_study_1_moic,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_1_moic",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_1_moic",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v("Please insert summary of sample investment 1."),
                      ]),
                      _vm._v(" "),
                      _c("autosize-textarea", {
                        attrs: {
                          placeholder: "",
                          rows: "2",
                          name: "case_study_1_summary",
                        },
                        model: {
                          value: _vm.questionaireForm.case_study_1_summary,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_1_summary",
                              $$v
                            )
                          },
                          expression: "questionaireForm.case_study_1_summary",
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_1_summary",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "30px" } }, [
                        _vm._v(
                          "Please insert project name of sample investment 2."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.questionaireForm.case_study_2_project_name,
                            expression:
                              "questionaireForm.case_study_2_project_name",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.case_study_2_project_name,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_2_project_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_2_project_name",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v("How much was invested?"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.questionaireForm.case_study_2_amount_invested,
                            expression:
                              "questionaireForm.case_study_2_amount_invested",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value:
                            _vm.questionaireForm.case_study_2_amount_invested,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_2_amount_invested",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_2_amount_invested",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v("What gross return did you achieve (IRR %)?"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.case_study_2_irr,
                            expression: "questionaireForm.case_study_2_irr",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.case_study_2_irr,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_2_irr",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_2_irr",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v(
                          "What gross return did you achieve (Equity Multiple / MOIC (x))?"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.case_study_2_moic,
                            expression: "questionaireForm.case_study_2_moic",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.case_study_2_moic,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_2_moic",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_2_moic",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v("Please insert summary of sample investment 2."),
                      ]),
                      _vm._v(" "),
                      _c("autosize-textarea", {
                        attrs: {
                          placeholder: "",
                          rows: "2",
                          name: "case_study_2_summary",
                        },
                        model: {
                          value: _vm.questionaireForm.case_study_2_summary,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_2_summary",
                              $$v
                            )
                          },
                          expression: "questionaireForm.case_study_2_summary",
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_2_summary",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "30px" } }, [
                        _vm._v(
                          "Please insert project name of sample investment 3."
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.questionaireForm.case_study_3_project_name,
                            expression:
                              "questionaireForm.case_study_3_project_name",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.case_study_3_project_name,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_3_project_name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_3_project_name",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v("How much was invested?"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.questionaireForm.case_study_3_amount_invested,
                            expression:
                              "questionaireForm.case_study_3_amount_invested",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value:
                            _vm.questionaireForm.case_study_3_amount_invested,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_3_amount_invested",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_3_amount_invested",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v("What gross return did you achieve (IRR %)?"),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.case_study_3_irr,
                            expression: "questionaireForm.case_study_3_irr",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.case_study_3_irr,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_3_irr",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_3_irr",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v(
                          "What gross return did you achieve (Equity Multiple / MOIC (x))?"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.case_study_3_moic,
                            expression: "questionaireForm.case_study_3_moic",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-bottom": "0" },
                        attrs: { type: "text" },
                        domProps: {
                          value: _vm.questionaireForm.case_study_3_moic,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_3_moic",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_3_moic",
                        },
                      }),
                      _vm._v(" "),
                      _c("label", { staticStyle: { "padding-top": "10px" } }, [
                        _vm._v("Please insert summary of sample investment 3."),
                      ]),
                      _vm._v(" "),
                      _c("autosize-textarea", {
                        attrs: {
                          placeholder: "",
                          rows: "2",
                          name: "case_study_3_summary",
                        },
                        model: {
                          value: _vm.questionaireForm.case_study_3_summary,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.questionaireForm,
                              "case_study_3_summary",
                              $$v
                            )
                          },
                          expression: "questionaireForm.case_study_3_summary",
                        },
                      }),
                      _vm._v(" "),
                      _c("show-error", {
                        attrs: {
                          "form-name": _vm.questionaireForm,
                          "prop-name": "case_study_3_summary",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.step == 5 && !_vm.is_loading && _vm.is_premium
            ? _c(
                "div",
                { staticClass: "pta-steps" },
                [
                  _c("h3", [_vm._v("PROFILE:")]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "What fund administration services are you in need of?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_1,
                            expression: "questionaireForm.fund_admin_1",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "fu1_1",
                          name: "fu1",
                          value: "1",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.fund_admin_1
                          )
                            ? _vm._i(_vm.questionaireForm.fund_admin_1, "1") >
                              -1
                            : _vm._q(_vm.questionaireForm.fund_admin_1, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.fund_admin_1,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "1",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "fund_admin_1",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(1),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_1,
                            expression: "questionaireForm.fund_admin_1",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "fu1_2",
                          name: "fu1",
                          value: "2",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.fund_admin_1
                          )
                            ? _vm._i(_vm.questionaireForm.fund_admin_1, "2") >
                              -1
                            : _vm._q(_vm.questionaireForm.fund_admin_1, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.fund_admin_1,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "2",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "fund_admin_1",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(2),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_1,
                            expression: "questionaireForm.fund_admin_1",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "fu1_3",
                          name: "fu1",
                          value: "3",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.fund_admin_1
                          )
                            ? _vm._i(_vm.questionaireForm.fund_admin_1, "3") >
                              -1
                            : _vm._q(_vm.questionaireForm.fund_admin_1, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.fund_admin_1,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "3",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "fund_admin_1",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(3),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_1,
                            expression: "questionaireForm.fund_admin_1",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "fu1_4",
                          name: "fu1",
                          value: "4",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.fund_admin_1
                          )
                            ? _vm._i(_vm.questionaireForm.fund_admin_1, "4") >
                              -1
                            : _vm._q(_vm.questionaireForm.fund_admin_1, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.fund_admin_1,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "4",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "fund_admin_1",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(4),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_1,
                            expression: "questionaireForm.fund_admin_1",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "fu1_5",
                          name: "fu1",
                          value: "5",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.fund_admin_1
                          )
                            ? _vm._i(_vm.questionaireForm.fund_admin_1, "5") >
                              -1
                            : _vm._q(_vm.questionaireForm.fund_admin_1, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.fund_admin_1,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "5",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "fund_admin_1",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(5),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_1,
                            expression: "questionaireForm.fund_admin_1",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "fu1_6",
                          name: "fu1",
                          value: "6",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.fund_admin_1
                          )
                            ? _vm._i(_vm.questionaireForm.fund_admin_1, "6") >
                              -1
                            : _vm._q(_vm.questionaireForm.fund_admin_1, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.fund_admin_1,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "6",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "fund_admin_1",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(6),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_1,
                            expression: "questionaireForm.fund_admin_1",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "fu1_7",
                          name: "fu1",
                          value: "7",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.fund_admin_1
                          )
                            ? _vm._i(_vm.questionaireForm.fund_admin_1, "7") >
                              -1
                            : _vm._q(_vm.questionaireForm.fund_admin_1, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.fund_admin_1,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "7",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "fund_admin_1",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(7),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_1,
                            expression: "questionaireForm.fund_admin_1",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "fu1_8",
                          name: "fu1",
                          value: "8",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.fund_admin_1
                          )
                            ? _vm._i(_vm.questionaireForm.fund_admin_1, "8") >
                              -1
                            : _vm._q(_vm.questionaireForm.fund_admin_1, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.fund_admin_1,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "8",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "fund_admin_1",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(8),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_1,
                            expression: "questionaireForm.fund_admin_1",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "fu1_9",
                          name: "fu1",
                          value: "9",
                          "true-value": [],
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.questionaireForm.fund_admin_1
                          )
                            ? _vm._i(_vm.questionaireForm.fund_admin_1, "9") >
                              -1
                            : _vm._q(_vm.questionaireForm.fund_admin_1, []),
                        },
                        on: {
                          change: function ($event) {
                            var $$a = _vm.questionaireForm.fund_admin_1,
                              $$el = $event.target,
                              $$c = $$el.checked ? [] : false
                            if (Array.isArray($$a)) {
                              var $$v = "9",
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.questionaireForm,
                                    "fund_admin_1",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.questionaireForm,
                                "fund_admin_1",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                      _vm._m(9),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v(
                      "In which jurisdiction will the Structure be established?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "name",
                      "track-by": "id",
                      name: "fund_admin_2_id",
                      id: "fund_admin_2_id",
                      options: _vm.jurisdictions,
                      placeholder: "Please choose",
                      multiple: true,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                      selected: _vm.selected_fund_admin_2,
                    },
                    on: {
                      select: _vm.onFundAdmin2Select,
                      remove: _vm.onFundAdmin2Remove,
                    },
                    model: {
                      value: _vm.selected_fund_admin_2,
                      callback: function ($$v) {
                        _vm.selected_fund_admin_2 = $$v
                      },
                      expression: "selected_fund_admin_2",
                    },
                  }),
                  _vm._v(" "),
                  _vm.show_fund_admin_2_other
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_2_other,
                            expression: "questionaireForm.fund_admin_2_other",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-top": "10px" },
                        attrs: { type: "text", placeholder: "Other option" },
                        domProps: {
                          value: _vm.questionaireForm.fund_admin_2_other,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_2_other",
                              $event.target.value
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v(
                      "Could you specify the preferred structure for the vehicle?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "name",
                      "track-by": "id",
                      name: "fund_admin_3_id",
                      id: "fund_admin_3_id",
                      options: _vm.vehicle_structures,
                      placeholder: "Please choose",
                      multiple: true,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                      selected: _vm.selected_fund_admin_3,
                    },
                    on: {
                      select: _vm.onFundAdmin3Select,
                      remove: _vm.onFundAdmin3Remove,
                    },
                    model: {
                      value: _vm.selected_fund_admin_3,
                      callback: function ($$v) {
                        _vm.selected_fund_admin_3 = $$v
                      },
                      expression: "selected_fund_admin_3",
                    },
                  }),
                  _vm._v(" "),
                  _vm.show_fund_admin_3_other
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_3_other,
                            expression: "questionaireForm.fund_admin_3_other",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-top": "10px" },
                        attrs: { type: "text", placeholder: "Other option" },
                        domProps: {
                          value: _vm.questionaireForm.fund_admin_3_other,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_3_other",
                              $event.target.value
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v("When is the vehicle's expected launch date?"),
                  ]),
                  _vm._v(" "),
                  _c("VueCtkDateTimePicker", {
                    attrs: {
                      format: "YYYY-MM-DD",
                      "no-label": true,
                      "no-header": false,
                      formatted: "DD.MM.YYYY",
                      color: "#20365F",
                      "only-date": true,
                      label: "none",
                      "button-now-translation": "today",
                    },
                    model: {
                      value: _vm.questionaireForm.fund_admin_4,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_4", $$v)
                      },
                      expression: "questionaireForm.fund_admin_4",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v("How many closes do you expect?"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.fund_admin_5,
                        expression: "questionaireForm.fund_admin_5",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.fund_admin_5 },
                    on: {
                      keypress: _vm.onlyNumber,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "fund_admin_5",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("What is the vehicle's term (In years)?"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.fund_admin_6,
                        expression: "questionaireForm.fund_admin_6",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.fund_admin_6 },
                    on: {
                      keypress: _vm.onlyNumber,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "fund_admin_6",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "What extensions are allowed in the vehicle term (in years)?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.fund_admin_7,
                        expression: "questionaireForm.fund_admin_7",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.fund_admin_7 },
                    on: {
                      keypress: _vm.onlyNumber,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "fund_admin_7",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("Will the vehicle use leverage? ")]),
                  _vm._v(" "),
                  _c("ul", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_8,
                            expression: "questionaireForm.fund_admin_8",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_8_yes",
                          name: "fund_admin_8",
                          value: "Yes",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_8,
                            "Yes"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_8",
                              "Yes"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_8_yes" } }, [
                        _vm._v("Yes"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_8,
                            expression: "questionaireForm.fund_admin_8",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_8_no",
                          name: "fund_admin_8",
                          value: "No",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_8,
                            "No"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_8",
                              "No"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_8_no" } }, [
                        _vm._v("No"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", [_vm._v("What is the expected vehicle size?")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.fund_admin_9,
                        expression: "questionaireForm.fund_admin_9",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.fund_admin_9 },
                    on: {
                      keypress: _vm.onlyNumber,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "fund_admin_9",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("What is the fund status?")]),
                  _vm._v(" "),
                  _c("ul", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_10,
                            expression: "questionaireForm.fund_admin_10",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_10_ce",
                          name: "fund_admin_10",
                          value: "Closed Ended",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_10,
                            "Closed Ended"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_10",
                              "Closed Ended"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_10_ce" } }, [
                        _vm._v("Closed Ended"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_10,
                            expression: "questionaireForm.fund_admin_10",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_10_oe",
                          name: "fund_admin_10",
                          value: "Open Ended",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_10,
                            "Open Ended"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_10",
                              "Open Ended"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_10_oe" } }, [
                        _vm._v("Open Ended"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "If open ended, please describe the liquidity provisions afforded to investors in the vehicle"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("autosize-textarea", {
                    style: "margin-bottom:10px;",
                    attrs: { rows: "2", name: "fund_admin_11" },
                    model: {
                      value: _vm.questionaireForm.fund_admin_11,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_11", $$v)
                      },
                      expression: "questionaireForm.fund_admin_11",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("Can you describe the basic investment strategy?"),
                  ]),
                  _vm._v(" "),
                  _c("autosize-textarea", {
                    style: "margin-bottom:30px;",
                    attrs: { rows: "2", name: "fund_admin_12" },
                    model: {
                      value: _vm.questionaireForm.fund_admin_12,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_12", $$v)
                      },
                      expression: "questionaireForm.fund_admin_12",
                    },
                  }),
                  _vm._v(" "),
                  _c("h3", [_vm._v("INVESTMENTS:")]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "On an annual basis, how many investments is this vehicle projected to undertake?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.fund_admin_13,
                        expression: "questionaireForm.fund_admin_13",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.fund_admin_13 },
                    on: {
                      keypress: _vm.onlyNumber,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "fund_admin_13",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "Provide details regarding the expected size range of individual investments (Ticket size)."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.fund_admin_14,
                        expression: "questionaireForm.fund_admin_14",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.fund_admin_14 },
                    on: {
                      keypress: _vm.onlyAmount,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "fund_admin_14",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("How long is the investment period (in years)?"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.fund_admin_15,
                        expression: "questionaireForm.fund_admin_15",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.fund_admin_15 },
                    on: {
                      keypress: _vm.onlyNumber,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "fund_admin_15",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "How long is the liquidation period expected to last (in years)?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.fund_admin_16,
                        expression: "questionaireForm.fund_admin_16",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.fund_admin_16 },
                    on: {
                      keypress: _vm.onlyNumber,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "fund_admin_16",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("How will the investments be held?")]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      name: "fund_admin_17_id",
                      id: "fund_admin_17_id",
                      options: _vm.investment_types,
                      placeholder: "Please choose",
                      multiple: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                    },
                    model: {
                      value: _vm.questionaireForm.fund_admin_17,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_17", $$v)
                      },
                      expression: "questionaireForm.fund_admin_17",
                    },
                  }),
                  _vm._v(" "),
                  _vm.questionaireForm.fund_admin_17 == "Other"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_17_other,
                            expression: "questionaireForm.fund_admin_17_other",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-top": "10px" },
                        attrs: { type: "text", placeholder: "Other option" },
                        domProps: {
                          value: _vm.questionaireForm.fund_admin_17_other,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_17_other",
                              $event.target.value
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v("Where will the investments be located?"),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "name",
                      "track-by": "id",
                      name: "fund_admin_18_id",
                      id: "fund_admin_18_id",
                      options: _vm.countries,
                      placeholder: "Please choose",
                      multiple: true,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                      selected: _vm.selected_fund_admin_18,
                    },
                    on: {
                      select: _vm.onFundAdmin18Select,
                      remove: _vm.onFundAdmin18Remove,
                    },
                    model: {
                      value: _vm.selected_fund_admin_18,
                      callback: function ($$v) {
                        _vm.selected_fund_admin_18 = $$v
                      },
                      expression: "selected_fund_admin_18",
                    },
                  }),
                  _vm._v(" "),
                  _c("h3", { staticStyle: { "padding-top": "30px" } }, [
                    _vm._v("SERVICES/REPORTING:"),
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "At what intervals do you need the Net Asset Value calculations to be performed?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      name: "fund_admin_19_id",
                      id: "fund_admin_19_id",
                      options: _vm.periods,
                      placeholder: "Please choose",
                      multiple: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                    },
                    model: {
                      value: _vm.questionaireForm.fund_admin_19,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_19", $$v)
                      },
                      expression: "questionaireForm.fund_admin_19",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v(
                      "Could you provide a concise overview of your approach to valuation?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      name: "fund_admin_20_id",
                      id: "fund_admin_20_id",
                      options: _vm.valuation_approaches,
                      placeholder: "Please choose",
                      multiple: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                    },
                    model: {
                      value: _vm.questionaireForm.fund_admin_20,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_20", $$v)
                      },
                      expression: "questionaireForm.fund_admin_20",
                    },
                  }),
                  _vm._v(" "),
                  _vm.questionaireForm.fund_admin_20 == "Other"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_20_other,
                            expression: "questionaireForm.fund_admin_20_other",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-top": "10px" },
                        attrs: { type: "text", placeholder: "Other option" },
                        domProps: {
                          value: _vm.questionaireForm.fund_admin_20_other,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_20_other",
                              $event.target.value
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v(
                      "At what intervals do you need the management accounts to be provided?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      name: "fund_admin_21_id",
                      id: "fund_admin_21_id",
                      options: _vm.periods,
                      placeholder: "Please choose",
                      multiple: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                    },
                    model: {
                      value: _vm.questionaireForm.fund_admin_21,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_21", $$v)
                      },
                      expression: "questionaireForm.fund_admin_21",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v("How frequent will investor reporting be required?"),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      name: "fund_admin_22_id",
                      id: "fund_admin_22_id",
                      options: _vm.periods,
                      placeholder: "Please choose",
                      multiple: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                    },
                    model: {
                      value: _vm.questionaireForm.fund_admin_22,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_22", $$v)
                      },
                      expression: "questionaireForm.fund_admin_22",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v(
                      "At what intervals do you require investor newsletters to be distributed?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      name: "fund_admin_23_id",
                      id: "fund_admin_23_id",
                      options: _vm.periods,
                      placeholder: "Please choose",
                      multiple: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                    },
                    model: {
                      value: _vm.questionaireForm.fund_admin_23,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_23", $$v)
                      },
                      expression: "questionaireForm.fund_admin_23",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v(
                      "How frequent is statutory reporting and drafting audited financial statements required?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      name: "fund_admin_24_id",
                      id: "fund_admin_24_id",
                      options: _vm.periods,
                      placeholder: "Please choose",
                      multiple: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                    },
                    model: {
                      value: _vm.questionaireForm.fund_admin_24,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_24", $$v)
                      },
                      expression: "questionaireForm.fund_admin_24",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v("What accounting standard do you employ?"),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      name: "fund_admin_25_id",
                      id: "fund_admin_25_id",
                      options: _vm.accounting_standards,
                      placeholder: "Please choose",
                      multiple: false,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                    },
                    model: {
                      value: _vm.questionaireForm.fund_admin_25,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_25", $$v)
                      },
                      expression: "questionaireForm.fund_admin_25",
                    },
                  }),
                  _vm._v(" "),
                  _vm.questionaireForm.fund_admin_25 == "Other"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_25_other,
                            expression: "questionaireForm.fund_admin_25_other",
                          },
                        ],
                        staticClass: "pta-form-text",
                        staticStyle: { "margin-top": "10px" },
                        attrs: { type: "text", placeholder: "Other option" },
                        domProps: {
                          value: _vm.questionaireForm.fund_admin_25_other,
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_25_other",
                              $event.target.value
                            )
                          },
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v("Will the fund accounts be consolidated?"),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_26,
                            expression: "questionaireForm.fund_admin_26",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_26_yes",
                          name: "fund_admin_26",
                          value: "Yes",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_26,
                            "Yes"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_26",
                              "Yes"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_26_yes" } }, [
                        _vm._v("Yes"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_26,
                            expression: "questionaireForm.fund_admin_26",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_26_no",
                          name: "fund_admin_26",
                          value: "No",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_26,
                            "No"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_26",
                              "No"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_26_no" } }, [
                        _vm._v("No"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "Do you require assistance with regards to your obligations under FATCA/CRS?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_27,
                            expression: "questionaireForm.fund_admin_27",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_27_yes",
                          name: "fund_admin_27",
                          value: "Yes",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_27,
                            "Yes"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_27",
                              "Yes"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_27_yes" } }, [
                        _vm._v("Yes"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_27,
                            expression: "questionaireForm.fund_admin_27",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_27_no",
                          name: "fund_admin_27",
                          value: "No",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_27,
                            "No"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_27",
                              "No"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_27_no" } }, [
                        _vm._v("No"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("Do you require US Tax compliance solutions?"),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_28,
                            expression: "questionaireForm.fund_admin_28",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_28_yes",
                          name: "fund_admin_28",
                          value: "Yes",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_28,
                            "Yes"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_28",
                              "Yes"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_28_yes" } }, [
                        _vm._v("Yes"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_28,
                            expression: "questionaireForm.fund_admin_28",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_28_no",
                          name: "fund_admin_28",
                          value: "No",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_28,
                            "No"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_28",
                              "No"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_28_no" } }, [
                        _vm._v("No"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "Is there a need for services related to the generation of board meeting minutes?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("ul", { staticStyle: { "margin-bottom": "30px" } }, [
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_29,
                            expression: "questionaireForm.fund_admin_29",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_29_yes",
                          name: "fund_admin_29",
                          value: "Yes",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_29,
                            "Yes"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_29",
                              "Yes"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_29_yes" } }, [
                        _vm._v("Yes"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("li", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.questionaireForm.fund_admin_29,
                            expression: "questionaireForm.fund_admin_29",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "fund_admin_29_no",
                          name: "fund_admin_29",
                          value: "No",
                        },
                        domProps: {
                          checked: _vm._q(
                            _vm.questionaireForm.fund_admin_29,
                            "No"
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$set(
                              _vm.questionaireForm,
                              "fund_admin_29",
                              "No"
                            )
                          },
                        },
                      }),
                      _c("label", { attrs: { for: "fund_admin_29_no" } }, [
                        _vm._v("No"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("h3", [_vm._v("INVESTORS:")]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v("Where do you expect investors to come from?"),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "name",
                      "track-by": "id",
                      name: "fund_admin_30_id",
                      id: "fund_admin_30_id",
                      options: _vm.countries,
                      placeholder: "Please choose",
                      multiple: true,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                      selected: _vm.selected_fund_admin_30,
                    },
                    on: {
                      select: _vm.onFundAdmin30Select,
                      remove: _vm.onFundAdmin30Remove,
                    },
                    model: {
                      value: _vm.selected_fund_admin_30,
                      callback: function ($$v) {
                        _vm.selected_fund_admin_30 = $$v
                      },
                      expression: "selected_fund_admin_30",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v(
                      "What type of investors will invest into the vehicle?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "name",
                      "track-by": "id",
                      name: "fund_admin_31_id",
                      id: "fund_admin_31_id",
                      options: _vm.investor_types_options,
                      placeholder: "Please choose",
                      multiple: true,
                      "close-on-select": true,
                      "clear-on-select": false,
                      "hide-selected": true,
                      placeholder: "Please choose",
                      selectLabel: "choose",
                      selected: _vm.selected_fund_admin_31,
                    },
                    on: {
                      select: _vm.onFundAdmin31Select,
                      remove: _vm.onFundAdmin31Remove,
                    },
                    model: {
                      value: _vm.selected_fund_admin_31,
                      callback: function ($$v) {
                        _vm.selected_fund_admin_31 = $$v
                      },
                      expression: "selected_fund_admin_31",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { staticStyle: { "padding-top": "10px" } }, [
                    _vm._v(
                      "How many investors do you expect this vehicle to have?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.questionaireForm.fund_admin_32,
                        expression: "questionaireForm.fund_admin_32",
                      },
                    ],
                    staticClass: "pta-form-text",
                    staticStyle: { "margin-bottom": "30px" },
                    attrs: { type: "text" },
                    domProps: { value: _vm.questionaireForm.fund_admin_32 },
                    on: {
                      keypress: _vm.onlyNumber,
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.questionaireForm,
                          "fund_admin_32",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("h3", [_vm._v("OTHER:")]),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "What is the name of the legal entity serving as the General Partner within this structure?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("autosize-textarea", {
                    style: "margin-bottom:10px;",
                    attrs: { rows: "2", name: "fund_admin_34" },
                    model: {
                      value: _vm.questionaireForm.fund_admin_33,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_33", $$v)
                      },
                      expression: "questionaireForm.fund_admin_33",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "What is the name of the legal entity taking on the role of Management Company or Investment Advisor in this setup?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("autosize-textarea", {
                    style: "margin-bottom:10px;",
                    attrs: { rows: "2", name: "fund_admin_36" },
                    model: {
                      value: _vm.questionaireForm.fund_admin_34,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_34", $$v)
                      },
                      expression: "questionaireForm.fund_admin_34",
                    },
                  }),
                  _vm._v(" "),
                  _c("label", [
                    _vm._v(
                      "Could you kindly disclose the identity of your other service providers (legal advisors, tax, audit, banking, etc.)?"
                    ),
                  ]),
                  _vm._v(" "),
                  _c("autosize-textarea", {
                    style: "margin-bottom:10px;",
                    attrs: { rows: "2", name: "fund_admin_36" },
                    model: {
                      value: _vm.questionaireForm.fund_admin_35,
                      callback: function ($$v) {
                        _vm.$set(_vm.questionaireForm, "fund_admin_35", $$v)
                      },
                      expression: "questionaireForm.fund_admin_35",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          (((_vm.step == 5 || _vm.step == 6) &&
            !_vm.is_loading &&
            _vm.is_premium) ||
            (_vm.step == 4 && !_vm.is_loading && !_vm.is_premium)) &&
          !_vm.is_premium
            ? _c("div", { staticClass: "pta-steps" }, [
                _vm._v(
                  "\n          Thanks for submitting the form. We will analyse your submission internally and reach out to you at the email address provided. In the meantime, please head to the Calendar section and schedule a call with us in about two weeks’ time so we can start discussing potential synergies.\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step == 6 && !_vm.is_loading && _vm.is_premium
            ? _c("div", { staticClass: "pta-steps" }, [
                _vm._v("\n          Thanks for submitting the form.\n        "),
              ])
            : _vm._e(),
          _vm._v(" "),
          (_vm.step < 5 && !_vm.is_loading && _vm.is_premium) ||
          (_vm.step < 4 && !_vm.is_loading && !_vm.is_premium) ||
          (_vm.step < 6 && !_vm.is_loading && _vm.is_premium)
            ? _c(
                "a",
                {
                  staticClass: "pta-button",
                  attrs: { href: "#", disabled: _vm.is_send },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.goNext.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Next")]
              )
            : _vm._e(),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pta-clear" }),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticStyle: { "padding-top": "30px" } }, [
      _vm._v("General description of your company "),
      _c("span", [_vm._v("(Optional)")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "fu1_1" } }, [
      _vm._v("Accounting & Fund Bookkeeping"),
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            "font-size": "0.875em",
            "line-height": "1.5em",
          },
        },
        [
          _vm._v(
            "Accounting (preparation of the financial statements), bookkeeping and payment services. Calculating and making capital and income distributions."
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "fu1_2" } }, [
      _vm._v("AIFM Services"),
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            "font-size": "0.875em",
            "line-height": "1.5em",
          },
        },
        [
          _vm._v(
            "Risk management, Portfolio management (including Investment Committee if required), Governance, through the oversight of delegated activity and investor reporting."
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "fu1_3" } }, [
      _vm._v("Company Secretarial"),
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            "font-size": "0.875em",
            "line-height": "1.5em",
          },
        },
        [
          _vm._v(
            "Corporate governance, effective administration and compliance."
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "fu1_4" } }, [
      _vm._v("Depositary Services"),
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            "font-size": "0.875em",
            "line-height": "1.5em",
          },
        },
        [
          _vm._v(
            "Cash flow monitoring, safe keeping and record keeping of assets, Oversight & supervision of delegates and service providers of the Fund, Annual inventory of assets and audit confirmations"
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "fu1_5" } }, [
      _vm._v("Vehicle and Legal Entities Incorporation"),
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            "font-size": "0.875em",
            "line-height": "1.5em",
          },
        },
        [
          _vm._v(
            "Review of documentation and assistance with the implementation of the Fund structure"
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "fu1_6" } }, [
      _vm._v("Directorships"),
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            "font-size": "0.875em",
            "line-height": "1.5em",
          },
        },
        [
          _vm._v(
            "Appointment of experienced Directors, board meetings attendance, financial statement review."
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "fu1_7" } }, [
      _vm._v("NAV Calculation"),
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            "font-size": "0.875em",
            "line-height": "1.5em",
          },
        },
        [_vm._v("Periodic Net Asset Value Calculations")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "fu1_8" } }, [
      _vm._v("Transfer Agency"),
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            "font-size": "0.875em",
            "line-height": "1.5em",
          },
        },
        [
          _vm._v(
            "Transfer agency (no retail investors, only professional and/or institutional investors), Anti-Money Laundering / Know-Your-Customer on the shareholders. Processing transfers and redemptions."
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "fu1_9" } }, [
      _vm._v("Vehicle and Legal Entities Incorporation"),
      _c(
        "span",
        {
          staticStyle: {
            display: "block",
            "font-size": "0.875em",
            "line-height": "1.5em",
          },
        },
        [
          _vm._v(
            "Review of documentation and assistance with the implementation of the Fund structure"
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }